"use strict";
// https://statsapi.mlb.com/api/v1/game/530482/content?language=en
Object.defineProperty(exports, "__esModule", { value: true });
